export const importModal = (callback = null) => {
  if (window.hurricane.staticHash && window.hurricane.staticHash.modal) {
    const script = document.createElement('script');
    let cdnHost = 'https://storm-frontend-cdn.dandythrust.com';

    if (window.location.host.includes('student')) {
      cdnHost = 'https://cdn.student.com';
    }
    script.src = `${cdnHost}/cdn-static/account-modal/dist/modal.${window.hurricane.staticHash.modal}.js`;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };

    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    head.appendChild(link);
    link.href = `${cdnHost}/cdn-static/account-modal/dist/modal.${window.hurricane.staticHash.modal}.css`;
  }
};

export const todo = () => {};
